import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_af7ezrsy57: FaireCollectionEntity = {
  token: "pbc_af7ezrsy57",
  type: "collection",
  name: "In-Stock Baby Cardigans & Pullovers (Sweater Knits)",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d39792abd5b7f0f9d930f125d2ae4d53c718aba0af9fa9399af8be486855d6fb.jpeg",
  itemCount: 119,
  description:
    "Discover our in-stock collection of organic cotton baby cardigans and pullovers in soft sweater knits. Ready to ship and designed for layering, these cozy styles feature timeless silhouettes and charming details for everyday comfort.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:19.318Z",
    importedBy: "entity-db-import-collections",
  },
};
